import { useEffect, useRef, useState } from "react";
import evokeLogo from "../../assets/images/evoke_logo.png";
import centraLogo from "../../assets/images/centra-logo.png";
import brookhavenLogo from "../../assets/images/brookhaven-heart-logo.jpg";
import brooklynHypertensionLogo from "../../assets/images/brooklyn-hypertension-logo.jpeg";
import { LETTER_TEMPLATE_STYLE } from "static/constants";

const toBase64 = async (url) => {
  // If already a data URL, extract just the base64 part
  if (url.startsWith("data:")) {
    return url.split(",")[1];
  }
  // Otherwise fetch and convert
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(",")[1]);
    reader.readAsDataURL(blob);
  });
};

const LetterTemplatePreview = ({ content }) => {
  const iframeRef = useRef(null);
  const [logos, setLogos] = useState(null);

  useEffect(() => {
    const loadLogos = async () => {
      const [
        evokeBase64,
        centraBase64,
        brookhavenBase64,
        brooklynHypertensionBase64,
      ] = await Promise.all([
        toBase64(evokeLogo),
        toBase64(centraLogo),
        toBase64(brookhavenLogo),
        toBase64(brooklynHypertensionLogo),
      ]);
      setLogos({
        evokeBase64,
        centraBase64,
        brookhavenBase64,
        brooklynHypertensionBase64,
      });
    };
    loadLogos();
  }, []);

  useEffect(() => {
    if (!logos || !content) return;
    const iframe = iframeRef.current;
    if (!iframe) return;

    const processedContent = content
      .replace(/\{\{\s*logoImageUrl\s*\}\}/g, logos.evokeBase64)
      .replace(/\{\{\s*centraLogoImageUrl\s*\}\}/g, logos.centraBase64)
      .replace(/\{\{\s*brookhavenLogoImageUrl\s*\}\}/g, logos.brookhavenBase64)
      .replace(
        /\{\{\s*brooklynHypertensionLogoImageUrl\s*\}\}/g,
        logos.brooklynHypertensionBase64
      )
      .replace(/\{\{\s*styles\s*\}\}/g, LETTER_TEMPLATE_STYLE);

    const doc = iframe.contentDocument;
    doc.open();
    doc.write(processedContent);
    doc.close();
  }, [content, logos]);

  return (
    <iframe
      ref={iframeRef}
      sandbox="allow-same-origin"
      title="HTML Preview"
      style={{
        p: 3,
        width: "100%",
        minHeight: 520,
        maxHeight: 520,
        height: "100%",
        borderRadius: 1,
        overflowY: "auto",
        backgroundColor: "#fff",
        border: "1px solid #e0e0e0",
      }}
    />
  );
};

export default LetterTemplatePreview;
